import React from "react";
import { BeerContainer } from "./BeerMenu";

export type BeerItemDisplayProps = {
  id: number;
  name: string;
  breweryLocation: string;
  style: string;
  abv: number;
  ibu: number;
  containers: BeerContainer[];
  brewery: string;
  tapNumber: number;
};

function decimalsIfNeeded(num: number) {
  return Math.round(num * 100) / 100;
}

function formatABV(abv: number) {
  return `${decimalsIfNeeded(abv)}% ABV`;
}

function formatIBU(ibu: number) {
  // eslint-disable-next-line
  return ibu == 0 ? "" : ` • ${decimalsIfNeeded(ibu)} IBU`;
}

export default class BeerItemDisplay extends React.Component<BeerItemDisplayProps> {
  render() {
    return (
      <div className="grid grid-cols-12 gap-0 mb-2 break-inside-avoid-column">
        <div className="col-span-1 font-bold text-5xl bg-amber-400 flex items-center justify-center">
          {this.props.tapNumber}.
        </div>

        <div className="col-span-11 bg-stone-800 pl-3">
          <div className="text-5xl font-bold text-left text-slate-100">
            {this.props.name}
          </div>
          <div className="text-4xl font-bold text-left text-amber-400 italic">
            {this.props.brewery}
          </div>
          <div className="text-left font-bold text-2xl text-slate-400">
            {this.props.style} • {formatABV(this.props.abv)}
            {formatIBU(this.props.ibu)}
          </div>

          <div className="col-span-2 bg-stone-700 pr-3">
            {this.props.containers.map(
              (container: BeerContainer, idx: number) => {
                return (
                  <span
                    className="float-left font-bold text-2xl"
                    key={container.name + idx}
                  >
                    <span className="italic font-bold text-amber-400">
                      {container.name}{" "}
                    </span>
                    <span className="italic font-bold text-slate-100">
                      {decimalsIfNeeded(container.price)}
                      {idx < 2 ? (
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      ) : null}
                    </span>
                  </span>
                );
              }
            )}
          </div>
        </div>
      </div>
    );
  }
}
